import { useTranslation } from '@mint-lib/i18n';

import { EmptyState } from './EmptyState.jsx';

export const GridEmptyState = () => {
  const { t } = useTranslation('@myn/import-hub');

  return (
    <EmptyState
      icon="IllustrationNoResults"
      text={t('No results found')}
      description={t(
        'Try adjusting your search in order to find what you are looking for.',
      )}
      className="shadow-none"
    />
  );
};
